import URL from 'url-parse';
import { curry } from 'ramda';

var schemePart = /(https?):\/\//;
var hostPart = /((?:\*\.)?(?:\w|\d|-)+(?:\.(?:\w|\d|-)+)*|\*)/;
var portPart = /:(\d+|\*)/;
var parser = new RegExp("^(?:" + schemePart.source + ")?(?:" + hostPart.source + ")(?:" + portPart.source + ")?$", 'i');
/**
 * @internal
 */
function parseSourceExpression(sourceExpression) {
    var match = sourceExpression.match(parser);
    if (match === null) {
        return null;
    }
    var scheme = (match[1] && match[1].toLowerCase()) || null;
    var host = match[2];
    var port = match[3] || null;
    return { scheme: scheme, host: host, port: port };
}
var DEFAULT_PORT = {
    http: '80',
    https: '443',
};
function parseOrigin(origin) {
    var url = new URL(origin);
    var hostname = url.hostname, port = url.port;
    var scheme = url.protocol.replace(':', '');
    if (!scheme.match(/https?/)) {
        throw new Error("Unsupported scheme in " + origin);
    }
    return {
        host: hostname,
        port: port || DEFAULT_PORT[scheme],
        scheme: scheme,
    };
}
/**
 * Partial implementation of the Matching Source Expression algorithm for
 * Content Security Policy Level 2.
 * https://www.w3.org/TR/CSP2/
 *
 * Assumptions:
 * - sourceExpression is a `host-source` as defined by the spec. If a protocol
 *   is specified, only HTTP or HTTPS are allowed
 * - The "protected resource" is hosted over HTTP or HTTPS protocol.
 * - We only support matching origin, not entire URL (with path) since
 *   entire URL are not available cross-origin.
 */
function matchOrigin(origin, sourceExpression) {
    var source = parseSourceExpression(sourceExpression);
    if (source === null) {
        throw new Error("Unsupported source expression " + source);
    }
    var parsedOrigin = parseOrigin(origin);
    // 4.1
    if (!parsedOrigin.host)
        return false;
    // 4.4
    if (source.scheme && parsedOrigin.scheme !== source.scheme)
        return false;
    // 4.5.1
    if (!source.scheme && !parsedOrigin.scheme.match(/https?/i))
        return false;
    // 4.6
    if (source.host[0] === '*') {
        var domain = source.host.slice(1);
        if (domain && domain !== parsedOrigin.host.slice(-domain.length))
            return false;
    }
    // 4.7
    if (source.host[0] !== '*' && source.host !== parsedOrigin.host)
        return false;
    // 4.8 disallow source exression from being an IPv4 address, which is is not
    // implemennted by browsers.
    // 4.9
    if (!source.port && parsedOrigin.port !== DEFAULT_PORT[parsedOrigin.scheme])
        return false;
    // 4.10
    if (source.port && source.port !== '*' && source.port !== parsedOrigin.port)
        return false;
    // 4.11 deals with the URL path, which we don't use.
    return true;
}
var matchOrigin$1 = curry(matchOrigin);

export default matchOrigin$1;
export { parseSourceExpression };
